import './processes.css';
import * as React from 'react';
import {Component} from "react";
import {ProcessSingle} from "../../widgets";
import {setActiveMenuItem, setLogoWhite, setNavbarTheme} from "../../util";



export class ProcessFive extends Component {

    componentDidMount() {
        setNavbarTheme('#040f2b');
        setActiveMenuItem('prosess', window.innerWidth < 1000);
        setLogoWhite(false);
    }

    render() {
        return (
            <div className={'process-five'}>
                <ProcessSingle header={'5. Produktet'} text={'Lorem Ipsum'} image={'resources/blonomBag.jpg'}/>
            </div>
        );
    }
}